import React from "react";
import { Outlet } from "react-router";
import { CareScreenerContextProvider } from "@context/CareScreenerContext";

/** Public and eager: the screener is also installed as a PWA and must render from a cold start. */
export function ScreenerLayout() {
  return (
    <CareScreenerContextProvider>
      <Outlet />
    </CareScreenerContextProvider>
  );
}

export { default as Consult } from "../pages/Consult";
export { default as PCScreener } from "../pages/PCScreener";
export { default as Screener } from "../pages/Screener";
export { default as Lyra } from "../pages/Lyra";
export { default as NewAccount } from "../pages/NewAccount";
export { default as NewAccountAndConsult } from "../pages/NewAccountAndConsult";
